import {Button, Text, DeviceType} from '@gongxigames/framework/core';
import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {AutoplayView} from '@gongxigames/framework/slot/modules/autoplay/AutoplayView';

export class AutoplayViewDesktop extends AutoplayView {
    public static readonly NAME: symbol = Symbol('AutoplayViewDesktop');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.DESKTOP;

    // using only for hiding / showing
    protected _autoplayButton!: Button;

    protected _autoSpinPanel!: Sprite;

    protected _defaultAutoplayFieldTextY!: number;
    protected _defaultAutoplayFieldTextHeight!: number;

    protected initGraphicElements(): void {
        super.initGraphicElements();

        this._autoSpinPanel = this.mainSprite.getChildByName<Sprite>('autoSpinPanel');
        this._autoSpinPanel.visible = false;
        this._autoplayFieldText = this._autoSpinPanel.getChildByName<Text>('txt');
        this._defaultAutoplayFieldTextY = this._autoplayFieldText.y;
        this._defaultAutoplayFieldTextHeight = this._autoplayFieldText.height;

        this.autoplayButton = this.mainSprite.getChildByName<Button>('autoButton');
    }

    public stopAutoplayButtonClickAction(): void {
    }

    public setAutoplayFieldText(text: string): void {
        if (text === 'Infinity') {
            this._autoplayFieldText.text = 'UNTIL\nBONUS WIN';
            // TODO: needs to be fixed!
            this._autoplayFieldText.y = this._defaultAutoplayFieldTextY -
                (this._autoplayFieldText.height - this._defaultAutoplayFieldTextHeight) / 2 + 22;
        } else {
            this._autoplayFieldText.text = text;
            this._autoplayFieldText.y = this._defaultAutoplayFieldTextY;
        }
    }

    public hideAutoplayUI(): void {
        if (this._disabledAutoplayButton) {
            return;
        }

        super.hideAutoplayUI();

        this._autoSpinPanel.visible = false;
        this._autoplayButton.visible = true;
    }

    public showAutoplayUI(): void {
        if (this._disabledAutoplayButton) {
            return;
        }

        super.showAutoplayUI();

        this._autoSpinPanel.visible = true;
        this._autoplayButton.visible = false;
    }

    protected onStopAutoplayButtonClicked(): void {
        super.onStopAutoplayButtonClicked();

        this._stopAutoplayButton.visible = false;
        this._autoSpinPanel.visible = false;
    }

    public startAutoplayButtonEvent(): void {
        this._autoSpinPanel.visible = true;
    }

    public set autoplayButton(value: Button) {
        this._autoplayButton = value;
    }
}
